
// Parent Modules
//import { hero } from './modules/hero';
import { locationsList } from './modules/locations-list';
import { moduleMap } from './modules/map';
// import newsletterSignup from './modules/newsletter-signup';
import { promoSlider } from './modules/promo-slider';
import { imageSlider } from './modules/image-slider';
import { videoPlayer } from './modules/video-player';
import { moduleSpacesFeed } from './modules/private-event-spaces-feed';
import { moduleMenus } from './modules/menus';
import { faqsFilter } from './modules/faqs';

import { hoverVideo } from './functions/hover-video';
import { inlineVideo } from './functions/inline-video';
import { locationSearchSubmit } from './functions/location-search';
import { popupNav } from './functions/popup-nav';
import { mobileNav } from './functions/mobile-nav';
import { closePopupsButtonWatcher, triggerCustomPopups } from './functions/popups';
import { footerNavAccordion } from './functions/footer-nav-accordion';
import { faqsAccordion } from './functions/faqs-accordion';
import { newsletterSignupFunctionality } from './functions/newsletter-signup';
// import { urlParams } from './functions/url-params';


//Child Theme Specific JS
//import './components/atreemoForm';

import { urlParams } from './functions/url-params';
import { moduleFuseFeed } from '../js/modules/fuse-feed';
import { scrollToLinks } from '../js/modules/scroll-to-links';
import { cardSlider } from '../js/modules/card-slider';
import { menuItemSlider } from '../js/modules/menu-item-slider';
import { imageSlider } from '../js/modules/image-slider';
import { contentSlider } from '../js/modules/content-slider';
import { heroSlider } from '../js/modules/hero-slider';
import { findUs } from '../js/modules/find-us';
import { enquiryForm } from '../js/modules/enquiry-form';
//import { toggleCursor } from './components/cursor';
import { fadeInOnScroll } from './functions/fade-in-on-scroll';
import { header } from './components/header';
import { newsletter } from './components/newsletter';
import { socialPill } from './components/social-pill';
import { lenis, stopSmoothScroll, startSmoothScroll } from './functions/smooth-scroll';




export default initJS = () => {

	document.querySelector('body').classList.remove('no-js');
	document.querySelector('#js__body').classList.remove('no-js');

	//Modules
	cardSlider();
	moduleMap();
	promoSlider();
	imageSlider();
	videoPlayer();
	moduleSpacesFeed();
	moduleFuseFeed();
	moduleMenus();
	locationsList();
	menuItemSlider();
	contentSlider();
	findUs();
	enquiryForm();
	locationSearchSubmit();
	mobileNav();
	footerNavAccordion();
	faqsAccordion();
	faqsFilter();
	newsletterSignupFunctionality();
	scrollToLinks();
	socialPill();

	//Global Parent Functions
	header();
	newsletter();
	popupNav();
	closePopupsButtonWatcher();
	triggerCustomPopups();
	urlParams();
	hoverVideo();
	inlineVideo();

	fadeInOnScroll();



}